























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Watch } from 'vue-property-decorator';
import dayjs from 'dayjs';
import InformationIcon from 'mdi-vue/InformationOutline';
import SearchField from '@/components/SearchField.vue';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import TagInput from '@/components/TagInput.vue';
import Loader from '@/components/Loader.vue';
import FormInput from '@/components/FormInput.vue';
import api, { apiProduction, apiSandbox } from '@/libs/api';
import {
  MerchantsManagement, ProvinceList, CityList, DistrictList,
} from '@/libs/api.interfaces';
import Modal from '@/components/Modal.vue';
// import axios from 'axios';
import Select from '@/components/Select.vue';
import Button from '@/components/Button.vue';
import CloseIcon from 'mdi-vue/Close';
import DownloadIcon from 'mdi-vue/Download';
// eslint-disable-next-line import/no-cycle
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import numberFormat from '@/libs/numberFormat';
import { ValidationObserver } from 'vee-validate';
import Toggle from '@/components/Toggle.vue';
import FileInput from '@/components/FileInput.vue';
import axios from 'axios';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';
import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import Cell from '@/components/Table/Cell.vue';

@Component({
  components: {
    ValidationObserver,
    LayoutTitle,
    LayoutContent,
    StatusIndicator,
    Loader,
    SearchField,
    TagInput,
    Select,
    FormInput,
    Button,
    Modal,
    CloseIcon,
    Toggle,
    InformationIcon,
    FileInput,
    DownloadIcon,
    ScrollbarWrapper,
    Table,
    TableBody,
    Row,
    Header,
    Cell,
  },
  methods: {
    numberFormat,
  },
})

export default class MerchantAdd extends Vue {
  data!: MerchantsManagement;
  showModal = false;
  showModalApprove = false;
  showModalApprove1 = false;
  loading = false;
  toggleStatus = false;
  merchantName = '';
  entityName = '';
  modalImage = '';
  modalFileName = '';
  businessCategory: any = '';
  trafficAverage: any = '';
  amountAverage: any = '';
  merchantWebsite = '';
  paymentUrl = '';
  country = 'Indonesia';
  brandName = '';
  bankName = '';
  bankBranch = '';
  bankAccountName = '';
  phoneNumber = '';
  merchantLogo = '';
  merchantURLPage = '';
  postalCode = '';
  npwpAddress = '';
  address = '';
  merchantBrand = '';
  MCC = '';
  faxNumber = '';
  customerType = '';
  npwpNumber = '';
  picBusinessFullName = ''
  picBusinessEmail = '';
  picBusinessPhoneNumber = '';
  pictechnicalFullName = '';
  picBtechnicalEmail = '';
  pictechnicalPhoneNumber = '';
  picFinanceFullName = ''
  picFinanceEmail = '';
  picFinancePhoneNumber = '';
  merchantPanelAccount = '';
  merchantPanelName = '';
  merchantPanelEmail = '';
  MerchantPanelPhoneNumber = '';
  notificationEmail: { value: string }[] = [];
  dailyReport: { value: string }[] = [];
  settlementReport: { value: string }[] = [];
  status = '';
  $refs!: {
    fileInput: HTMLInputElement;
  }

  caption = '';
  mainMerchantMerchName = '';
  merchantNPWP = '';
  merchantSIUP = '';
  merchantTDP = '';
  directorIdentityCard = '';
  directorName = '';
  directorIdentityCardNumber = '';
  directorNPWP = '';
  directorNPWPNumber = '';
  merchantLogoName = '';
  merchantNPWPName = '';
  merchantSIUPName = '';
  MerchantTDPName = '';
  directorIdentityCardName = '';
  aktaPendirianPerubahan = '';
  aktaPendirianPerubahanName = '';
  siup = '';
  siupName = '';
  skMenteriKehakiman = '';
  skMenteriKehakimanName = '';
  directorNPWPName = '';
  province: { id?: number } | null = null;
  provinceList: { id: number; country_id: number; name: string }[] = [];
  city: { id?: number } | null = null;
  citylist: { id: number; name: string }[] = [];
  district: { id?: number } | null = null;
  districtlist: { id: number; name: string }[] = [];
  subDistrict: { id?: number; name: string; postalCode: string } | null = null;
  subDistrictlist: { id: number; name: string; postalCode: string }[] = [];
  bankList: any = [];

  merchantLeadStatus: any = '';
  historyRequest: any = [];

  reason = '';

  approveStatus = '';

  trafficAverageOption = [
    { id: 1, label: '< 25' },
    { id: 2, label: '25 - 100' },
    { id: 3, label: '100 - 700' },
    { id: 4, label: '700+' },
  ];

  amountAverageOption = [
    { id: 1, label: 'IDR < 200K' },
    { id: 2, label: 'IDR 200 - 500K' },
    { id: 3, label: 'IDR 500 - 1500K' },
    { id: 4, label: 'IDR 1500K+' },
  ];

  categoryCodes: { label: string; value: number }[] = [];

  loadingCountry = false;
  loadingProvince = false;
  loadingCity = false;
  loadingDistrict = false;
  loadingSubDistrict = false;
  loadingDownloadImage = false;
  showAction = true;
  showSaveAndExit = true;

  enabled = false;

  roles = '';
  merchantReseller = false;

  // eslint-disable-next-line class-methods-use-this
  dateFormat(time: string) {
    const formatted = dayjs(time).format('MMMM D, YYYY HH:mm:ss');
    if (formatted === 'Invalid Date') {
      return '-';
    }

    return formatted;
  }

  // eslint-disable-next-line class-methods-use-this
  sttsMerchantLead(stts: number) {
    let status;
    // eslint-disable-next-line default-case
    switch (stts) {
      case 0: status = 'New Merchant';
        break;
      case 1: status = 'Active Merchant';
        break;
      case 2: status = 'Potential Merchant';
        break;
      case 3: status = 'Uncomplete Merchant';
        break;
      case 4: status = 'Underwriting Merchant';
        break;
      case 5: status = 'Close';
        break;
      case 6: status = 'Temporary Deactivate';
        break;
      default: status = 'Potential Merchant';
    }
    return status;
  }

  close() {
    this.showModalApprove = false;
    this.showModalApprove1 = false;
  }

  async sameLevelApproval() {
    const id = this.$route.params.type;
    try {
      this.loading = true;
      await apiSandbox.post('/consumer/approval/merchant/same-level-approval', {
        /* eslint-disable @typescript-eslint/camelcase */
        merchant_code: id,
        action: this.approveStatus,
        reason: this.reason ? this.reason : null,
      });
      showToast(ToastType.SUCCESS, 'Success', 'Update information');
      this.loading = false;
      this.$router.push('/merchant-lead');
    } catch (err) {
      showToast(ToastType.FAILED, 'Oops… Sorry', (err as any).response.data.error);
      this.loading = false;
    }
  }

  async moveMLtoAM() {
    const id = this.$route.params.type;
    try {
      this.loading = true;
      await apiSandbox.post('/consumer/approval/merchant/lead-to-am', {
        merchant_code: id,
        action: this.approveStatus,
        reason: this.reason ? this.reason : null,
      });
      showToast(ToastType.SUCCESS, 'Success', 'Update information');
      this.loading = false;
      this.$router.push('/merchant-lead');
    } catch (err) {
      showToast(ToastType.FAILED, 'Oops… Sorry', (err as any).response.data.error.errors.map((e: any) => e.message));
      this.loading = false;
    }
  }

  async getMCC() {
    try {
      this.loading = true;
      const { data } = await api.get('/getMCC');
      this.categoryCodes = data.map((e: any) => ({
        label: e.category_name,
        value: e.category_code,
      }));
      if (!this.businessCategory) {
        this.businessCategory = this.categoryCodes.find((e) => e.value === Number(this.data.merchant_mcc) || null);
      }
      this.loading = false;
    } catch (err) {
      // console.error(err);
    }
  }

  handleFileName(val: [string, string]) {
    this.loading = false;
    if (val[0] === 'merchantLogo') {
      this.merchantLogoName = val[1].toString();
    } else if (val[0] === 'directorIdentityCard') {
      this.directorIdentityCardName = val[1].toString();
    } else if (val[0] === 'directorNPWP') {
      this.directorNPWPName = val[1].toString();
    } else if (val[0] === 'aktaPendirian') {
      this.aktaPendirianPerubahanName = val[1].toString();
    } else if (val[0] === 'merchantNPWP') {
      this.merchantNPWPName = val[1].toString();
    } else if (val[0] === 'merchantSIUP') {
      this.merchantSIUPName = val[1].toString();
    } else if (val[0] === 'SK') {
      this.skMenteriKehakimanName = val[1].toString();
    } else if (val[0] === 'merchantTDP') {
      this.MerchantTDPName = val[1].toString();
    }
  }

  async getProvince() {
    try {
      this.loading = false;
      this.loadingProvince = true;
      const { data } = await api.get<ProvinceList[]>('/countries', {
        params: {
          id: 1,
        },
      });
      this.provinceList = data[0].provinces.map((e) => ({
        id: e.id,
        // eslint-disable-next-line @typescript-eslint/camelcase
        country_id: Number(e.country_id),
        name: e.name,
      }));
      if (!this.province) {
        this.province = this.provinceList.find((e) => e.id === this.data.province) || null;
      } else {
        this.getCity();
      }
      this.loadingProvince = false;
    } catch (err) {
      // console.error(err);
    }
  }

  @Watch('province')
  async getCity() {
    if (this.province === null) return;
    this.loadingCity = true;
    try {
      this.loading = false;
      const { data } = await api.get<CityList[]>('/provinces', {
        params: {
          id: this.province.id,
        },
      });
      this.citylist = data[0].cities.map((e) => ({
        id: e.id,
        name: e.name,
      }));
      if (!this.city) {
        this.city = this.citylist.find((e) => e.id === Number(this.data.city)) || null;
      } else {
        this.getdistrict();
      }
      this.loadingCity = false;
    } catch (err) {
      // console.error(err);
    }
  }

  @Watch('city')
  async getdistrict() {
    if (this.city === null) return;
    try {
      this.loadingDistrict = true;
      this.loading = false;
      const { data } = await api.get<DistrictList[]>('/cities', {
        params: {
          id: this.city.id,
        },
      });
      this.districtlist = data[0].districts.map((e) => ({
        id: e.id,
        name: e.name,
      }));
      if (!this.district) {
        this.district = this.districtlist.find((e) => e.id === Number(this.data.district)) || null;
      } else {
        this.getSubdistrict();
      }
      this.loadingDistrict = false;
    } catch (err) {
      // console.error(err);
    }
  }

  @Watch('district')
  async getSubdistrict() {
    if (this.district === null) return;
    try {
      this.loadingSubDistrict = true;
      this.loading = false;
      const { data } = await api.get('/districts', {
        params: {
          id: this.district.id,
        },
      });
      this.subDistrictlist = data[0].sub_districts.map((e: any) => ({
        id: e.id,
        name: e.name,
        postalCode: e.zip_code,
      }));
      if (!this.subDistrict) {
        this.subDistrict = this.subDistrictlist.find((e) => e.id === Number(this.data.subdistrict)) || null;
      }
      this.loadingSubDistrict = false;
    } catch (err) {
      // console.error(err);
    }
  }

  @Watch('subDistrict')
  async getPostalCode() {
    if (this.subDistrict !== null) {
      this.postalCode = this.subDistrict.postalCode;
    }
  }

  mounted() {
    this.getMerchant();
    this.getBanks();

    this.roles = JSON.parse(localStorage.getItem('USER') || '{}').user.user_role.role;
    // console.log(this.roles);
  }

  cancel() {
    this.$router.push('/account-management');
    console.log(this.notificationEmail.map((e) => e.value));
  }

  showImage(val: string, name: string) {
    if (val) {
      this.showModal = true;
      this.modalImage = val;
      this.modalFileName = name;
    } else {
      // this.$refs.fileInput.click();
    }
  }

  showModalApproves(val: string) {
    this.approveStatus = val;
    if (val === 'APPROVED') {
      this.caption = 'Merchant will be approved if you click button Submit below';
    }

    if (val === 'DECLINED') {
      this.caption = 'Merchant will be declined if you click button Submit below';
    }
    this.showModalApprove = true;
  }

  showModalApproves1(val: string) {
    this.approveStatus = val;
    if (val === 'APPROVED') {
      this.caption = 'Merchant will be approved if you click button Submit below';
    }

    if (val === 'DECLINED') {
      this.caption = 'Merchant will be declined if you click button Submit below';
    }
    this.showModalApprove1 = true;
  }

  async downloadImage() {
    // this.loadingDownloadImage = true;

    // const fileLink = document.createElement('a');

    // const imageUrl = this.modalImage.replace(process.env.VUE_APP_API_URL || '', '');
    // const { data } = await api.get(`/download?file=${imageUrl}`, { responseType: 'blob' });
    // const img = URL.createObjectURL(data);

    // fileLink.href = img;
    // fileLink.download = `${this.modalFileName}.png`;
    // document.body.appendChild(fileLink);
    // fileLink.click();
    // document.body.removeChild(fileLink);
    // this.loadingDownloadImage = false;
    this.loadingDownloadImage = true;

    const url = new URL(this.modalImage);
    const fileLink = document.createElement('a');

    if (url.hostname.includes('dashboard')) {
      const { data } = await apiProduction.get(`/download?file=${url.pathname}`, { responseType: 'blob' });
      const img = URL.createObjectURL(data);
      fileLink.href = img;
    } else {
      const { data } = await apiSandbox.get(`/download?file=${url.pathname}`, { responseType: 'blob' });
      const img = URL.createObjectURL(data);
      fileLink.href = img;
    }

    fileLink.download = `${this.modalFileName}.png`;
    document.body.appendChild(fileLink);
    fileLink.click();
    document.body.removeChild(fileLink);
    this.loadingDownloadImage = false;
  }

  async getMerchant() {
    const id = this.$route.params.type;

    try {
      this.loading = true;
      const { data } = await apiSandbox.get(`/consumer/merchant/${id}`);
      this.data = data;
      /* eslint-disable max-len */
      // this.merchantLogo = data.merchant_logo && data.merchant_logo.length > 1 ? process.env.VUE_APP_SANDBOX_API_URL + data.merchant_logo : '';
      this.merchantLogoName = data.merchant_logo || '';
      // this.merchantNPWP = data.merchant_npwp_img && data.merchant_npwp_img.length > 1 ? process.env.VUE_APP_SANDBOX_API_URL + data.merchant_npwp_img : '';
      this.merchantNPWPName = data.merchant_npwp_img || '';
      // this.merchantSIUP = data.merchant_siup && data.merchant_siup.length > 1 ? process.env.VUE_APP_SANDBOX_API_URL + data.merchant_siup : '';
      this.merchantSIUPName = data.merchant_siup || '';
      // this.merchantTDP = data.merchant_tdp && data.merchant_tdp.length > 1 ? process.env.VUE_APP_SANDBOX_API_URL + data.merchant_tdp : '';
      this.MerchantTDPName = data.merchant_tdp || '';
      // this.aktaPendirianPerubahan = data.merchant_akta ? process.env.VUE_APP_SANDBOX_API_URL + data.merchant_akta : '';
      this.aktaPendirianPerubahanName = data.merchant_akta || '';
      // this.skMenteriKehakiman = data.merchant_sk ? process.env.VUE_APP_SANDBOX_API_URL + data.merchant_sk : '';
      this.skMenteriKehakimanName = data.merchant_sk || '';
      if (data.merchant_pic) {
        // this.directorIdentityCard = data.merchant_pic.director_identity_card && data.merchant_pic.director_identity_card.length > 1 ? process.env.VUE_APP_SANDBOX_API_URL + data.merchant_pic.director_identity_card : '';
        this.directorIdentityCardName = data.merchant_pic ? data.merchant_pic.director_identity_card : '';
        this.directorIdentityCardNumber = data.merchant_pic ? data.merchant_pic.director_ktp_number : '';
        this.directorName = data.merchant_pic ? data.merchant_pic.director_name : '';
        this.directorNPWPNumber = data.merchant_pic ? data.merchant_pic.director_npwp_number : '';
        // this.directorNPWP = data.merchant_pic.director_npwp && data.merchant_pic.director_npwp.length > 1 ? process.env.VUE_APP_SANDBOX_API_URL + data.merchant_pic.director_npwp : '';
        this.directorNPWPName = data.merchant_pic ? data.merchant_pic.director_npwp : '';
        this.picBusinessFullName = data.merchant_pic.pic_business_name === '-' ? data.merchant_pic.pic_business_name.replaceAll('-', '') : data.merchant_pic.pic_business_name || '';
        this.picBusinessEmail = data.merchant_pic.pic_business_email === '-' ? data.merchant_pic.pic_business_email.replaceAll('-', '') : data.merchant_pic.pic_business_email || '';
        this.picBusinessPhoneNumber = data.merchant_pic === '-' ? data.merchant_pic.pic_business_phone.replaceAll('-', '') : data.merchant_pic.pic_business_phone || '';
        this.pictechnicalFullName = data.merchant_pic.pic_technical_name === '-' ? data.merchant_pic.pic_technical_name.replaceAll('-', '') : data.merchant_pic.pic_technical_name || '';
        this.picBtechnicalEmail = data.merchant_pic.pic_technical_email === '-' ? data.merchant_pic.pic_technical_email.replaceAll('-', '') : data.merchant_pic.pic_technical_email || '';
        this.pictechnicalPhoneNumber = data.merchant_pic.pic_technical_phone === '-' ? data.merchant_pic.pic_technical_phone.replaceAll('-', '') : data.merchant_pic.pic_technical_phone || '';
        this.picFinanceFullName = data.merchant_pic.pic_finance_name === '-' ? data.merchant_pic.pic_finance_name.replaceAll('-', '') : data.merchant_pic.pic_finance_name || '';
        this.picFinancePhoneNumber = data.merchant_pic.pic_finance_phone === '-' ? data.merchant_pic.pic_finance_phone.replaceAll('-', '') : data.merchant_pic.pic_finance_phone || '';
        this.picFinanceEmail = data.merchant_pic.pic_finance_email === '-' ? data.merchant_pic.pic_finance_email.replaceAll('-', '') : data.merchant_pic.pic_finance_email || '';
      }

      this.entityName = data.merchant_name || '';
      this.npwpNumber = data.merchant_npwp === '-' ? data.merchant_npwp.replaceAll('-', '') : data.merchant_npwp || '';
      this.npwpAddress = data.merchant_npwp_address === '-' ? data.merchant_npwp_address.replaceAll('-', '') : data.merchant_npwp_address || '';
      this.merchantBrand = data.merchant_brand || '';
      this.merchantWebsite = data.web_url === '-' ? data.web_url.replaceAll('-', '') : data.web_url || '';
      this.paymentUrl = data.payment_flag_url || '';
      this.address = data.merchant_address || '';
      this.postalCode = String(data.postal_code) || '';
      this.phoneNumber = data.merchant_phone === '-' ? data.merchant_phone.replaceAll('-', '') : data.merchant_phone || '';
      this.faxNumber = data.fax_number || '';
      this.bankName = data.bank_name === '-' ? data.bank_name.replaceAll('-', '') : data.bank_name || '';
      this.bankBranch = data.bank_branch === '-' ? data.bank_branch.replaceAll('-', '') : data.bank_branch || '';
      this.bankAccountName = data.bank_account_name === '-' ? data.bank_account_name.replaceAll('-', '') : data.bank_account_name || '';
      this.status = data.status || '';
      this.trafficAverage = this.trafficAverageOption.find((e) => e.id === data.trx_traffic);
      this.amountAverage = this.amountAverageOption.find((e) => e.id === data.trx_amount);
      this.toggleStatus = data.status === 'ACTIVE';
      this.merchantLeadStatus = data.merchant_lead_status;
      this.historyRequest = data.history_request;
      if (data.status === 'CLOSED' || data.alt_status === 'CLOSED') {
        this.showAction = false;
        this.showSaveAndExit = false;
        this.enabled = false;
      } else {
        this.enabled = true;
        switch (this.roles) {
          case 'Sales Acquisition':
            this.showAction = data.merchant_approval?.approved_by_sales === 0 && data.merchant_approval?.rejected_by_sales === 0
            && this.merchantLeadStatus === 2;
            this.showSaveAndExit = data.merchant_approval?.approved_by_sales === 0 && data.merchant_approval?.rejected_by_sales === 1;
            // this.showAction = data.merchant_approval?.approved_by_sales ? this.showAction : this.showAction = true;
            break;

          case 'Operation':
            this.showAction = data.merchant_approval.approved_by_operation === false && data.merchant_approval.rejected_by_operation !== true;
            this.showSaveAndExit = false;
            break;

          case 'Risk & Mitigation':
            this.showAction = data.merchant_approval.approved_by_sales === 1 && this.merchantLeadStatus === 4;
            // this.showAction = data.merchant_approval.approved_by_sales === true || data.merchant_approval.approved_by_operation;
            this.showSaveAndExit = false;
            break;

          default:
        }
      }
      this.loading = false;
      /* eslint-disable max-len */
      // this.notificationEmail = data.email_notification ? JSON.parse(data.email_notification).map((e: any) => ({ key: '', value: e })) : '';
      // this.dailyReport = data.email_daily_report ? JSON.parse(data.email_daily_report).map((e: any) => ({ key: '', value: e })) : '';
      // this.settlementReport = data.email_settlement_repot ? JSON.parse(data.email_settlement_repot).map((e: any) => ({ key: '', value: e })) : '';
      if (!this.trafficAverage) {
        this.trafficAverage = this.trafficAverageOption.find((e) => e.id === Number(this.data.trx_traffic) || null);
      }

      if (!this.amountAverage) {
        this.amountAverage = this.amountAverageOption.find((e) => e.id === Number(this.data.trx_amount) || null);
      }
      if (data.is_merchant_reseller) {
        this.merchantReseller = true;
        this.mainMerchantMerchName = data.main_merchant_reseller.merchant_name;
      }
      this.getMCC();
      this.getProvince();
    } catch (err) {
      console.error(err);
      showToast(
        ToastType.FAILED,
        'Error',
        'Failed to get transaction detail',
      );
    }
  }

  async addMerchant() {
    // if (this.province === null) return;
    // if (this.city === null) return;
    // if (this.district === null) return;
    const id = this.$route.params.type;

    try {
      this.loading = true;
      await apiSandbox.put(`/merchant/${id}`, {
        /* eslint-disable @typescript-eslint/camelcase */
        merchant_logo: this.merchantLogoName,
        merchant_phone: this.phoneNumber,
        merchant_address: this.npwpAddress,
        merchant_brand: this.merchantBrand,
        cms_name: this.entityName,
        merchant_mcc: this.businessCategory?.value,
        country: 1,
        province: this.province?.id,
        city: this.city?.id,
        district: this.district?.id,
        subdistrict: this.subDistrict?.id,
        postal_code: this.postalCode,
        trx_traffic: this.trafficAverage.id,
        trx_amount: this.amountAverage.id,
        web_url: this.merchantWebsite,
        payment_flag_url: this.paymentUrl,
        director_identity_card: this.directorIdentityCardName,
        director_ktp_number: this.directorIdentityCardNumber,
        director_name: this.directorName,
        director_npwp: this.directorNPWPName,
        director_npwp_number: this.directorNPWPNumber,
        merchant_akta: this.aktaPendirianPerubahanName,
        merchant_siup: this.merchantSIUPName,
        merchant_npwp_img: this.merchantNPWPName,
        merchant_sk: this.skMenteriKehakimanName,
        merchant_tdp: this.MerchantTDPName,
        pic_business_name: this.picBusinessFullName,
        pic_business_email: this.picBusinessEmail,
        pic_business_phone: this.picBusinessPhoneNumber,
        pic_technical_name: this.pictechnicalFullName,
        pic_technical_email: this.picBtechnicalEmail,
        pic_technical_phone: this.pictechnicalPhoneNumber,
        pic_finance_name: this.picFinanceFullName,
        pic_finance_email: this.picFinanceEmail,
        pic_finance_phone: this.picFinancePhoneNumber,
        bank_name: this.bankName,
        bank_branch: this.bankBranch,
        bank_account_name: this.bankAccountName,
        // merchant_siup: this.siupName,
        merchant_name: this.entityName,
        status: this.toggleStatus ? 'ACTIVE' : 'INACTIVE',
        need_approval: 1,
        merchant_rekening: '-',
        fee_transaction: '-',
        fee_settlement: '-',
        web_information: '-',
        bi_code: '-',
        jenis: '-',
        receiver_cust_type: '-',
        receiver_cust_residence: '-',
        fax_number: '-',
        email_notification: '-',
        email_daily_report: '-',
        email_settlement_repot: '-',
        merchant_npwp_address: this.npwpAddress,
        merchant_npwp: this.npwpNumber,
      });
      showToast(ToastType.SUCCESS, 'Success', 'Update information');
      this.loading = false;
      this.$router.push('/merchant-lead');
    } catch (err) {
      showToast(ToastType.FAILED, 'Oops… Sorry', (err as any).response.data.error.errors.map((e: any) => e.message));
      this.loading = false;
    }
  }

  async getBanks() {
    try {
      const { data } = await api.get('/bank');
      const banks = data[0];
      this.bankList = Object.values(banks);
      // console.log(this.bankList);
    } catch (err) {
      showToast(ToastType.FAILED, 'Error', 'Failed to load bank list');
    }
  }
}
